/** Shared HTML policy for admin-entered rich content. Unknown elements are unwrapped;
 * dangerous elements, event attributes and non-http URLs are discarded. */
const safeTags=new Set(['p','div','br','h2','h3','h4','strong','b','em','i','u','s','ul','ol','li','blockquote','pre','code','a','mark','span','img','hr','table','thead','tbody','tr','th','td'])
const removeEntirely=new Set(['script','style','iframe','object','embed','svg','math','form','input','button','select','textarea','video','audio','link','meta','base','template','noscript'])
export function isRichHtml(value:string){return /<\/?(?:p|div|br|h[1-6]|strong|b|em|i|u|ul|ol|li|blockquote|pre|code|a|mark|span|img|table|tr|td|th)\b/i.test(value)}
function safeUrl(value:string){try{const url=new URL(value,window.location.origin);return (url.protocol==='https:'||url.protocol==='http:')?url.href:null}catch{return null}}
export function sanitizeRichHtml(source:string):string{
  if(typeof DOMParser==='undefined')return ''
  const parser=new DOMParser()
  const doc=parser.parseFromString('<main>'+String(source||'')+'</main>','text/html')
  const output=document.implementation.createHTMLDocument('')
  const root=output.createElement('div')
  const walk=(node:Node,destination:Node)=>{
    if(node.nodeType===Node.TEXT_NODE){destination.appendChild(output.createTextNode(node.textContent||''));return}
    if(node.nodeType!==Node.ELEMENT_NODE)return
    const element=node as Element,tag=element.localName.toLowerCase()
    if(removeEntirely.has(tag))return
    if(!safeTags.has(tag)){Array.from(element.childNodes).forEach(c=>walk(c,destination));return}
    const safe=output.createElement(tag)
    if(tag==='img'){
      const src=element.getAttribute('src')
      const url=src?safeUrl(src):null
      if(!url||!url.startsWith('https://'))return
      safe.setAttribute('src',url)
      safe.setAttribute('alt',(element.getAttribute('alt')||'').slice(0,120))
      safe.setAttribute('loading','lazy')
      safe.setAttribute('referrerpolicy','no-referrer')
      destination.appendChild(safe)
      return
    }
    if(tag==='a'){
      const href=element.getAttribute('href'),url=href?safeUrl(href):null
      if(url){safe.setAttribute('href',url);safe.setAttribute('target','_blank');safe.setAttribute('rel','noopener noreferrer')}
    }
    if(['span','mark','div','p','h2','h3','h4','blockquote'].includes(tag)){
      const style=element.getAttribute('style')||''
      const parts=style.split(';').map(x=>x.trim()).filter(Boolean)
      const allowed:string[]=[]
      for(const p of parts){
        const m=p.match(/^(background-color|color)\s*:\s*(#[0-9a-fA-F]{3,8}|rgb\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*\))$/i)
        if(m)allowed.push(m[1].toLowerCase()+':'+m[2])
      }
      const align=parts.map(p=>p.match(/^text-align\s*:\s*(left|right|center|justify)$/i)).find(Boolean)
      if(align && !['span','mark'].includes(tag))allowed.push('text-align:'+align[1].toLowerCase())
      if(allowed.length)safe.setAttribute('style',allowed.join(';'))
    }
    if(tag==='td'||tag==='th'){
      for(const attr of ['colspan','rowspan']){
        const n=Number(element.getAttribute(attr))
        if(Number.isInteger(n)&&n>1&&n<=10)safe.setAttribute(attr,String(n))
      }
    }
    Array.from(element.childNodes).forEach(c=>walk(c,safe))
    destination.appendChild(safe)
  }
  Array.from(doc.querySelector('main')?.childNodes||[]).forEach(c=>walk(c,root))
  return root.innerHTML
}
export function plainTextFromRich(value:string){
  const input=String(value||'')
  if(!isRichHtml(input))return input.replace(/\s+/g,' ').trim()
  if(typeof DOMParser!=='undefined'){
    const d=new DOMParser().parseFromString(input,'text/html')
    d.querySelectorAll('script,style,svg,iframe,template').forEach(n=>n.remove())
    return (d.body.textContent||'').replace(/\s+/g,' ').trim()
  }
  return input.replace(/<[^>]*>/g,' ').replace(/\s+/g,' ').trim()
}
